import { render, staticRenderFns } from "./OrgExternalDonorsTable.vue?vue&type=template&id=7d1151d1&"
import script from "./OrgExternalDonorsTable.vue?vue&type=script&lang=js&"
export * from "./OrgExternalDonorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports